var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarrningsvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9383 9.16738L4.82209 42.7499C4.40734 43.4681 4.18789 44.2825 4.18557 45.1119C4.18324 45.9413 4.39813 46.7568 4.80885 47.4774C5.21958 48.1979 5.81181 48.7984 6.52665 49.219C7.24148 49.6396 8.05399 49.8658 8.88334 49.8749H49.1158C49.9452 49.8658 50.7577 49.6396 51.4725 49.219C52.1874 48.7984 52.7796 48.1979 53.1903 47.4774C53.6011 46.7568 53.8159 45.9413 53.8136 45.1119C53.8113 44.2825 53.5918 43.4681 53.1771 42.7499L33.0608 9.16738C32.6374 8.46938 32.0413 7.89228 31.3299 7.49178C30.6186 7.09127 29.816 6.88086 28.9996 6.88086C28.1832 6.88086 27.3806 7.09127 26.6693 7.49178C25.9579 7.89228 25.3617 8.46938 24.9383 9.16738Z",
    fill: "#FFFAE6",
    stroke: "#FEC900",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 21.375V30.875",
    stroke: "#FEC900",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40.375H29.0243",
    stroke: "#FEC900",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrningsvg);
export default __webpack_public_path__ + "static/media/warrningsvg.878ebb8475ee0232a582e22c0752513f.svg";
export { ForwardRef as ReactComponent };